import script from "./insurance-form-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-form-page.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-form-page.vue?vue&type=style&index=0&id=30217106&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30217106"]])

export default __exports__